import { clamp } from '@common/helpers/math-helper';

export interface IntervalParameters {
    OFF: number;
    MIN: number;
    MAX: number;
    INITIAL: number;
    BACK_OFF: number; // back off increase multiplier, <=1 == don't back off
    MAX_ERRORS: number; //maximum number of errors to tolerate before we stop autoupdating
}

/**
 * update a polling interval according to a set of refreshParameters
 * @param currentRate what's the current rate, if it's OFF, it stays OFF
 * @param refreshParameters the parameters for incrementing
 */
export const incrementPollingRate = (currentRate: number, refreshParameters: IntervalParameters): number => {
    if (currentRate === refreshParameters.OFF) {
        return refreshParameters.OFF;
    }
    if (refreshParameters.BACK_OFF > 1 && currentRate < refreshParameters.MAX) {
        return clamp(
            Math.floor(currentRate * refreshParameters.BACK_OFF),
            refreshParameters.MIN,
            refreshParameters.MAX
        );
    }
    return currentRate;
};
